import React from "react"
import {connect} from "react-redux";
import {Route, Redirect, withRouter} from 'react-router-dom';

const CompanyRoutes = ({component: Component, auth, claim, loading, ...rest}) => {
    if (auth && claim === 'company'){
        return <Route {...rest} render={(props) => (
            <Component {...props}/>
        )} />
    } else {
        return <Route {...rest} render={(props) => (
            <Redirect to="/"/>
        )} />
    }
};

const mapStateToProps = (state) => ({
    auth: !!state.auth.uid, claim: state.auth.claim
});

export default withRouter(connect(mapStateToProps, undefined)(CompanyRoutes))